import {
  customScrollMinimal,
  SmartTable,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 32px;
  overflow-y: auto;
  padding: 20px;

  ${customScrollMinimal}

  ${SmartTable.Styled.Table} {
    tr {
      background-color: var(--background-soft);
      th,
      td {
        background-color: var(--background-soft);
      }
    }
  }
`;

export const StyledTitle = styled.div`
  ${typographyV2.titleLg};
`;

export const InsightTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DeepDiveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ValueInfo = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
